import { dedupeById, getPagination } from '@/utils/helpers';
import {
    FETCH_CUSTOMERS,
    FETCH_ORTHODONTIC_CUSTOMERS,
    FETCH_CUSTOMER,
    DELETE_CUSTOMERS,
    FETCH_ACTIVE_CUSTOMERS,
    FETCH_CUSTOMER_PHONES
} from '@/redux/actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    list: {
        items: [],
        pagination: {
            currentPage: 1,
            total: 0,
            perPage: 30,
        },
    },
    activeList: {
        items: [],
        pagination: {
            currentPage: 1,
            total: 0,
            perPage: 20,
        },
    },
    list_othodontic: {
        items: [],
        pagination: {
            currentPage: 1,
            total: 0,
            perPage: 30,
        },
    },
    phones: [],
    detail: null,
    createResult: null,
    updateResult: null,
    deleteResult: null
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        /**
         * Danh sách KH (load mới)
         */
        case FETCH_CUSTOMERS: {
            const payload = action.payload || {};
            return {
                ...state,
                list: {
                    items: payload.data || [],
                    pagination: getPagination(payload, 30),
                },
            };
        }

        /**
         * Danh sách KH chỉnh nha (load mới)
         */
        case FETCH_ORTHODONTIC_CUSTOMERS: {
            const payload = action.payload || {};
            return {
                ...state,
                list_othodontic: {
                    items: payload.data || [],
                    pagination: getPagination(payload, 30),
                },
            };
        }

        /**
         * Danh sách KH active (có thể dùng cho infinite scroll)
         * => nếu page 1: ghi đè; page >1: nối + dedupe
         */
        case FETCH_ACTIVE_CUSTOMERS: {
            const payload = action.payload || {};
            const isFirstPage = parseInt(payload.current_page, 10) === 1;

            const merged = isFirstPage
                ? (payload.data || [])
                : [...(state.activeList.items || []), ...(payload.data || [])];

            return {
                ...state,
                activeList: {
                    items: dedupeById(merged),
                    pagination: getPagination(payload, 20),
                },
            };
        }

        /**
         * Lấy chi tiết KH
         */
        case FETCH_CUSTOMER: {
            return {
                ...state,
                detail: action.payload || null,
            };
        }

        /**
         * Lấy danh sách sđt KH
         */
        case FETCH_CUSTOMER_PHONES:
            return {
                ...state,
                phones: action.payload
            };


        /**
         * Xoá KH
         */
        case DELETE_CUSTOMERS: {
            return {
                ...state,
                deleteResult: action.payload || null,
                // (tuỳ chọn) loại bỏ khỏi list/activeList nếu muốn đồng bộ UI ngay:
                // list: {
                //   ...state.list,
                //   items: (state.list.items || []).filter(i => i.id !== action.payload?.id)
                // },
                // activeList: {
                //   ...state.activeList,
                //   items: (state.activeList.items || []).filter(i => i.id !== action.payload?.id)
                // }
            };
        }

        default:
            return state;
    }
};
